import { render } from "./SettingImprest.vue?vue&type=template&id=337445ef"
import script from "./SettingImprest.vue?vue&type=script&lang=js"
export * from "./SettingImprest.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__